import { useEffect } from 'react';

// Safari's layout viewport does not shrink when the software keyboard opens.
export default function useViewportSize() {
  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => {
      document.documentElement.style.setProperty('--visible-height', `${viewport?.height || window.innerHeight}px`);
      document.documentElement.style.setProperty('--visible-top', `${viewport?.offsetTop || 0}px`);
    };
    update();
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      document.documentElement.style.removeProperty('--visible-height');
      document.documentElement.style.removeProperty('--visible-top');
    };
  }, []);
}
